module.exports = __webpack_public_path__ + "img/bkg-facelift-girl.d6a6c2eb.png";